import { render, staticRenderFns } from "./ColleaguesContacts.vue?vue&type=template&id=2254e290&scoped=true&"
import script from "./ColleaguesContacts.vue?vue&type=script&lang=js&"
export * from "./ColleaguesContacts.vue?vue&type=script&lang=js&"
import style0 from "./ColleaguesContacts.vue?vue&type=style&index=0&id=2254e290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2254e290",
  null
  
)

export default component.exports